import donutSpinner from '../assets/donut-spinner.png';

interface Props {
  label?: string;
}

export default function Spinner({ label = 'Loading…' }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '2rem 0',
      }}
    >
      <img
        src={donutSpinner}
        alt=""
        width={48}
        height={48}
        style={{ animation: 'spin 0.9s linear infinite' }}
      />
      <span style={{ opacity: 0.65, fontSize: '0.9rem' }}>{label}</span>
    </div>
  );
}
